module.exports = __webpack_public_path__ + "Flag-260.4055f33c6e416556af90f39b84dda03f.svg";